"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var chart_table_logic_1 = require("./chart-table.logic");
var angular = require("angular");
function ChartTableController($scope, $timeout) {
    var ctrl = this;
    // Terminology for dynamic text based on product type
    ctrl.terminology = {
        Portfolio: 'Portfolio',
        portfolio: 'portfolio',
        Portfolios: 'Portfolios'
    };
    // Listen for terminology response
    $scope.$on('terminology:response', function (event, terminology) {
        ctrl.terminology = terminology;
        // Regenerate table data with new terminology if data exists
        if (ctrl.tableData) {
            ctrl.$onChanges();
        }
    });
    // Request terminology from parent when component is ready
    $scope.$emit('terminology:request');
    ctrl.$onChanges = function () {
        if (!ctrl.tableData) {
            ctrl.formatedData = null;
            return;
        }
        var dataCopy = JSON.parse(JSON.stringify(ctrl.tableData));
        var inputData = dataCopy.inputData, settings = dataCopy.settings;
        if (settings) {
            ctrl.decimals = settings.decimals;
        }
        if (inputData) {
            // Check if this is transformed leaf node data
            // The transformLeafDataForTable function sets isLeafNodeData: true for data transformed from arrays
            var hidePortfolioElements = false;
            if (inputData.hasOwnProperty('isLeafNodeData') && inputData.isLeafNodeData === true) {
                // Only hide Portfolio Elements column if there's no sibling data to compare
                // When comparing leaf nodes, we want to show the Portfolio Elements column
                var hasSiblingData = inputData.siblingRows && inputData.siblingRows.length > 0;
                hidePortfolioElements = !hasSiblingData;
            }
            ctrl.formatedData = chart_table_logic_1.ChartTable.generateTable(__assign({}, dataCopy, { hidePortfolioElements: hidePortfolioElements, terminology: ctrl.terminology }));
        }
        else {
            ctrl.formatedData = null;
        }
        $timeout();
    };
    function exportCsv(filename, csvFormat, skipSave) {
        var csv = chart_table_logic_1.ChartTable.generateCsv(ctrl.formatedData, csvFormat, ctrl.terminology);
        if (!skipSave) {
            var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
            saveAs(blob, filename);
        }
        return csv;
    }
    $scope.$on('export:csv', function (event, args, callback) {
        var csv = exportCsv(args.filename, args.csvFormat, args.skipSave || false);
        if (callback) {
            callback(csv);
        }
    });
}
angular.module('smartorg.r6.cmpts.chartTable', []).filter('textOrNumber', ['$filter', function ($filter) {
        return function (input, fractionSize) {
            if (isNaN(input) || (fractionSize == "Default")) {
                return input;
            }
            else {
                return $filter('number')(input, fractionSize);
            }
        };
    }]).component("chartTable", {
    template: require("./chart-table.component.html"),
    controller: ChartTableController,
    bindings: {
        tableData: '<',
        showAlert: '&?'
    }
});
module.exports = 'smartorg.r6.cmpts.chartTable';
//# sourceMappingURL=chart-table.component.js.map


// WEBPACK FOOTER //
// ./app/components/chart-table/chart-table.component.js